<template>
  <div>
    <div class="col-12 text-center" v-if="isInit">
      <i class="fa fa-spin fa-spinner"></i> Loading Data
    </div>
    <b-row class="animated fadeIn" v-else>
      <b-col sm="4">
        <b-card>
          <div slot="header">
            <strong>Data</strong>
            <small>Pasien</small>
          </div>
          <b-row>
            <b-col sm="12">
              <table class="table table-striped" style="font-size: 12px">
                <tr>
                  <td><strong>Nama Pasien</strong></td>
                  <td>{{ pasien.nama_lengkap }}</td>
                </tr>
                <tr>
                  <td><strong>Umur</strong></td>
                  <td>{{ pasien.umur }} Tahun</td>
                </tr>
                <tr>
                  <td><strong>Jenis Kelamin</strong></td>
                  <td>{{ pasien.jk == 'L' ? 'Laki-Laki' : 'Perempuan' }}</td>
                </tr>
                <tr>
                  <td><strong>Alamat</strong></td>
                  <td>{{ pasien.alamat }}</td>
                </tr>
                <tr>
                  <td><strong>Tanggal Daftar</strong></td>
                  <td>{{ pasien.created_at | moment('Do MMMM YYYY HH:mm:ss') }}</td>
                </tr>
                <tr>
                  <td><strong>Jenis Pasien</strong></td>
                  <td>{{ pasien.jenis_pasien }}</td>
                </tr>
              </table>
            </b-col>
          </b-row>
        </b-card>
        <b-card>
          <div slot="header">
            <strong>Histori</strong>
            <small>Rekam Medis</small>
          </div>

          <div class="table-responsive" style="font-size:12px;">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Keterangan</th>
                  <th>Detail</th>
                </tr>
                <tr v-for="item in pasien.rekam_medis">
                  <td>{{ item.nomor_resep }} - {{ $moment(item.created_at).format('Do MMMM YYYY HH:mm') }}</td>
                  <td>
                    <button @click="detail(item)" class="btn btn-warning btn-sm"><i class="fa fa-th-list"></i></button>
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </b-card>
      </b-col>

      <b-col sm="8">
        <form>
          <b-card>
            <div slot="header">
              <strong>Form</strong>
              <small>Rekam Medis</small>
              <button @click="refreshForm" type="button" class="btn btn-success btn-sm pull-right"><i class="fa fa-refresh"></i> Kosongkan Form</button>
            </div>

            <b-col sm="12">
              <div class="alert alert-danger" v-if="errors.all().length != 0">
                <strong>Perhatian</strong>
                <ul>
                  <li v-for="error in errors.all()">{{ error }}</li>
                </ul>
              </div>
            </b-col>

            <b-col sm="12">
              <b-form-fieldset label="Nama Dokter" :label-cols="3" :horizontal="true">
                <v-select placeholder="[ Pilih Dokter ]" :options="list_dokter" v-model="rekam_medis.dokter"></v-select>
              </b-form-fieldset>
            </b-col>

            <b-col sm="12">
              <b-form-fieldset label="Keluhan" :label-cols="3" :horizontal="true">
                <textarea rows="3" name="keluhan" class="form-control" data-vv-as="Keluhan" v-bind:class="{ 'is-invalid': errors.has('keluhan') }" v-validate="'required'" type="text" id="keluhan" placeholder="Masukkan keluhan pasien" v-model="rekam_medis.keluhan"></textarea>
              </b-form-fieldset>
            </b-col>

            <b-col sm="12">
              <b-form-fieldset label="Diagnosa" :label-cols="3" :horizontal="true">
                <textarea rows="3" name="diagnosa" class="form-control" data-vv-as="Diagnosa" v-bind:class="{ 'is-invalid': errors.has('diagnosa') }" v-validate="'required'" type="text" id="diagnosa" placeholder="Masukkan diagnosa pasien" v-model="rekam_medis.diagnosa"></textarea>
              </b-form-fieldset>
            </b-col>

            <b-col sm="12">
              <b-form-fieldset label="Jasa Dokter" :label-cols="3" :horizontal="true">
                <money name="harga_dokter" class="form-control" data-vv-as="Jasa Dokter" v-bind:class="{ 'is-invalid': errors.has('harga_dokter') }" v-validate="'required|numeric'" type="text" id="harga_dokter" placeholder="Masukkan jasa dokter" v-model="rekam_medis.harga_dokter"></money>
              </b-form-fieldset>
            </b-col>
          </b-card>

          <!-- Tindakan -->
          <b-card>
            <b-col sm="12">
              <b-form-fieldset label="Tindakan" :label-cols="3" :horizontal="true">
                <button type="button" v-on:click.prevent="tindakan.push({})" class="btn btn-sm btn-primary"><i class="fa fa-medkit"></i> Tambah Tindakan</button>
                <span class="pull-right">Total {{ totalTindakan | toCurrency }}</span>
              </b-form-fieldset>
            </b-col>

            <b-col sm="12">
              <table class="table table-striped">
                <tr>
                  <th>Tindakan</th>
                  <th>Harga</th>
                  <th>Aksi</th>
                </tr>
                <tr v-for="item in tindakan">
                  <td>
                    <b-form-select data-vv-as="Tindakan" name="tindakan" v-bind:class="{ 'is-invalid': errors.has('tindakan') }" v-validate="'required'" class="col-sm-6" :options="list_tindakan" v-model="item.tindakan"></b-form-select>
                  </td>
                  <td>
                    <money v-model="item.harga" class="form-control" name="harga"></money>
                  </td>
                  <td><button type="button" v-on:click="tindakan.splice(tindakan.indexOf(item), 1)" class="btn btn-sm btn-danger"><i class="fa fa-times"></i></button></td>
                </tr>
              </table>
            </b-col>
          </b-card>
          <!-- End of Tindakan -->

          <!-- Inhalasi -->
          <b-card>
            <b-col sm="12">
              <b-form-fieldset label="Inhalasi" :label-cols="3" :horizontal="true">
                <button type="button" v-on:click="inhalasi.push({})" class="btn btn-sm btn-primary"><i class="fa fa-medkit"></i> Tambah Inhalasi</button>
                <span class="pull-right">Total Rp {{ totalInhalasi | toCurrency }}</span>
              </b-form-fieldset>
            </b-col>

            <b-col sm="12">
              <table class="table table-striped">
                <tr>
                  <th>Inhalasi</th>
                  <th>Harga</th>
                  <th>Aksi</th>
                </tr>
                <tr v-for="item in inhalasi">
                  <td>
                    <b-form-select data-vv-as="Inhalasi" name="inhalasi" v-bind:class="{ 'is-invalid': errors.has('inhalasi') }" v-validate="'required'" class="col-sm-6" :options="list_inhalasi" v-model="item.inhalasi"></b-form-select>
                  </td>
                  <td>
                    <money v-model="item.harga" class="form-control" name="harga"></money>
                  </td>
                  <td><button type="button" v-on:click="inhalasi.splice(inhalasi.indexOf(item), 1)" class="btn btn-sm btn-danger"><i class="fa fa-times"></i></button></td>
                  <span class="pull-right">Total Rp {{ terapi_obat.harga | toCurrency }}</span>
                </tr>
              </table>
            </b-col>
          </b-card>
          <!-- End of Inhalasi -->

          <!-- Terapi Obat -->
          <b-card>
            <b-col sm="12">
              <b-form-fieldset label="Terapi Obat" :label-cols="3" :horizontal="true">
                <button type="button" v-on:click="terapi_obat.push({})" class="btn btn-sm btn-primary"><i class="fa fa-medkit"></i> Tambah Obat</button>
                <span class="pull-right">Total Rp {{ totalObat | toCurrency }}</span>
              </b-form-fieldset>
            </b-col>

            <b-col sm="12">
              <table class="table table-striped">
                <tr>
                  <th width="80%">Nama Obat</th>
                  <th>Jumlah</th>
                  <th>Total</th>
                  <th>Aksi</th>
                </tr>
                <tr v-for="item in terapi_obat">
                  <td>
                    <v-select placeholder="[ Pilih Obat ]" :filterable="false" v-model="item.obat" :options="list_obat" @search="searchObat" @input="selected">
                      <template slot="no-options">
                        Data obat tidak ditemukan
                      </template>
                      <template slot="option" slot-scope="option">
                        {{ option.label }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.label }}
                      </template>
                    </v-select>
                  </td>
                  <td><input type="text" name="jumlah" v-model="item.jumlah" class="form-control"></td>
                  <td>
                    {{ item.obat != null ? toCurrency(item.obat.harga_jual * item.jumlah) : '' }}
                  </td>
                  <td><button type="button" v-on:click="terapi_obat.splice(terapi_obat.indexOf(item), 1)" class="btn btn-sm btn-danger"><i class="fa fa-times"></i></button></td>
                </tr>
              </table>
            </b-col>
          </b-card>
          <!-- End of Terapi Obat -->

          <!-- Biaya Adm -->
          <b-card>
            <b-col sm="12">
              <b-form-fieldset label="Biaya Administrasi" :label-cols="3" :horizontal="true">
                <money name="biaya_adm" class="form-control" data-vv-as="Biaya Administrasi" v-bind:class="{ 'is-invalid': errors.has('biaya_adm') }" v-validate="'required|numeric'" type="text" id="harga_dokter" placeholder="Masukkan biaya administrasi" v-model="rekam_medis.biaya_adm"></money>
              </b-form-fieldset>
            </b-col>
          </b-card>

          <!-- Rekap -->
          <b-card>
            <b-col sm="12">
              <table class="table table-striped">
                <tr>
                  <td>Jasa Dokter</td>
                  <td class="text-right">Rp {{ rekam_medis.harga_dokter | toCurrency }}</td>
                </tr>
                <tr>
                  <td>Tindakan</td>
                  <td class="text-right">Rp {{ totalTindakan | toCurrency }}</td>
                </tr>
                <tr>
                  <td>Inhalasi</td>
                  <td class="text-right">Rp {{ totalInhalasi | toCurrency }}</td>
                </tr>
                <tr>
                  <td>Terapi Obat</td>
                  <td class="text-right">Rp {{ totalObat | toCurrency }}</td>
                </tr>
                <tr>
                  <td>Biaya Administrasi</td>
                  <td class="text-right">Rp {{ rekam_medis.biaya_adm | toCurrency }}</td>
                </tr>
                <tr>
                  <th>Grand Total</th>
                  <th class="text-right">Rp {{ toCurrency(rekam_medis.harga_dokter + totalTindakan + totalInhalasi + totalObat + rekam_medis.biaya_adm) }}</th>
                </tr>
              </table>
            </b-col>
          </b-card>
          <!-- End of Terapi Obat -->

          <b-row>
            <b-col sm="12">
              <button v-bind:disabled="isLoading" v-if="rekam_medis.edit == null" @click="store" type="button" class="btn btn-block btn-success">
                <span v-if="isLoading"><i class="fa fa-spinner fa-spin"></i> Loading</span>
                <span v-else><i class="fa fa-save"></i> Simpan</span>
              </button>
              <button v-bind:disabled="isLoading" v-else @click="store" type="button" class="btn btn-block btn-warning">
                <span v-if="isLoading"><i class="fa fa-spinner fa-spin"></i> Loading</span>
                <span v-else><i class="fa fa-save"></i> Edit</span>
              </button>
            </b-col>
            <br />
            <br />
            <br />
          </b-row>
        </form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Pasien from '@/model/Pasien'
  import Obat from '@/model/Obat'

  export default {
    watch: {
      'item.obat': function (newVal) {
        alert(newVal)
      }
    },
    data: () => {
      return {
        asd: '',
        isInit: false,
        isLoading: false,
        usia: 0,
        id_pasien: '',
        dokter: {},
        kode_pasien: '',
        pasien: [],
        rekam_medis: {},
        config: {
          dateFormat: 'd-m-Y',
          allowInput: true
        },
        list_obat: [],
        list_dokter: [],
        list_inhalasi: [ 'Oksigen', 'Nebulizer' ],
        list_tindakan: [ 'Injeksi Standar', 'Injeksi Khusus', 'Insisi Abses', 'Jahitan Luka/Buka Jahitan', 'Perawatan Luka', 'Tes Kehamilan', 'Pemeriksaan Lab', 'KB', 'Lain-Lain' ],
        inhalasi: [],
        tindakan: [],
        terapi_obat: []
      }
    },
    methods: {
      selected (e) {
        if (e != null) {
          var index = this.terapi_obat.findIndex((i) => {
            return i.obat.kode_obat === e.kode_obat
          })
          if (e.stock <= 0 && e.edit !== true) {
            this.$swal('Perhatian', 'Stok obat tersebut habis', 'error')
            this.terapi_obat[index].obat = {}
          }
        }
      },
      async searchObat (search, loading) {
        loading(true)
        var obat = await Obat.searchObat(search)
        this.list_obat = obat.data
        loading(false)
      },
      detail (detail) {
        this.rekam_medis = detail
        this.rekam_medis.dokter = this.list_dokter.find(x => x.value === detail.id_dokter)
        this.tindakan = detail.tindakan
        this.inhalasi = detail.inhalasi
        this.terapi_obat = []
        detail.terapi_obat.forEach((e, i) => {
          this.terapi_obat.push({
            'jumlah': e.jumlah,
            'obat': {
              'harga_jual': e.harga,
              'kode_obat': e.detail_obat.kode_obat,
              'label': e.detail_obat.kode_obat + ' - ' + e.detail_obat.nama_obat + ' ' + e.harga,
              'edit': true
            }
          })
        })
        // this.list_obat = []
        // this.terapi_obat.forEach((e, i) => {
        // })
      },
      refreshForm () {
        this.rekam_medis = {}
        this.tindakan = []
        this.inhalasi = []
        this.terapi_obat = []
      },
      async getData () {
        try {
          const data = await Pasien.rekamMedisForm()
          this.list_dokter = data.data.dokter
          this.list_obat = data.data.obat
        } catch (e) {
          this.$toastr.e('Gagal mengambil data pasien, silahkan ulangi')
          this.$router.go(-1)
        }
      },
      async store () {
        this.isLoading = true
        try {
          var data = {
            pasien: this.pasien,
            rekam_medis: this.rekam_medis,
            tindakan: this.tindakan,
            inhalasi: this.inhalasi,
            terapi_obat: this.terapi_obat
          }
          await Pasien.addRekamMedis(data)
          this.$swal('Berhasil', 'Data rekam medis berhasil disimpan', 'success')
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
        this.isLoading = false
        this.refreshForm()
        this.getData()
        this.getPasienDetail()
      },
      async update () {
        try {
          const pasien = await Pasien.updatePasien(this.id_pasien, this.pasien)

          if (pasien.data.status) {
            this.$router.replace('/pasien')
            this.$toastr.s('Edit data pasien berhasil')
          }
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
      },
      async getPasienDetail () {
        try {
          this.isInit = true
          var pasien = await Pasien.getPasienDetail(this.kode_pasien)
          this.id_pasien = pasien.data.id
          this.pasien = pasien.data
          this.isInit = false
        } catch (e) {
          this.$toastr.e('Gagal mengambil data pasien, silahkan ulangi')
          this.$router.go(-1)
        }
      },
      submit () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (this.id_pasien !== '') this.update()
            else this.store()
          }
        })
      },
      cekHarga (val, el) {
        console.log(el)
      }
    },
    mounted () {
      this.kode_pasien = this.$route.params.id
      if (this.kode_pasien != null) {
        this.getPasienDetail()
      }

      this.getData()
    },
    computed: {
      hitungUsia () {
        var date = Vue.moment(this.pasien.tanggal_lahir, 'DD-MM-YYYY')
        return Vue.moment().diff(date, 'years')
      },
      totalTindakan: function () {
        var total = 0
        this.tindakan.forEach((val) => {
          if (val.harga != null) total += parseInt(val.harga)
        })
        if (isNaN(total)) return 0
        return total
      },
      totalInhalasi: function () {
        var total = 0
        this.inhalasi.forEach((val) => {
          if (val.harga != null) total += parseInt(val.harga)
        })
        if (isNaN(total)) return 0
        return total
      },
      totalObat: function () {
        var total = 0
        this.terapi_obat.forEach((val) => {
          if (val.obat != null) {
            total += parseInt(val.obat.harga_jual * val.jumlah)
          }
        })
        if (isNaN(total)) return 0
        return total
      }
    }
  }
</script>
